const bp = {
  smMobile: 320,
  mobile: 376,
  lgMobile:485,
  smTablet: 768,
  tablet: 992,
  desktop: 1200,
  lgDesktop: 1600,
}

export const palette = {
  white: '#FFFFFF',
  black: '#000000',
  grayOne: '#D7D8DA',
  grayTwo: '#979797',
  grayThree: '#363636',
  sbGrayOne: '#141414',
  sbGrayTwo: '#191919',
  orangeOne: '#FF9800',
  orangeTwo: '#F7760D',
  greenOne: '#80C33F',
  greenTwo: '#61B510',
  gold: '#FACB46',
};

export const mq = n => {
  const bpArray = Object.keys(bp).map(key => [key, bp[key]])

  const [result] = bpArray.reduce((acc, [name, size]) => {
    if (n === name) return [...acc, `@media (min-width: ${size}px)`]
    return acc
  }, [])

  return result
}

export const fontSize = (min, max) => {
  let maxMin = max - min; 

  return `
  font-size: ${min}px; 
  @media (min-width: 320px) and (max-width: 1200px){ 
    font-size: calc(${min}px + ${maxMin}*(100vw - 320px)/880)
  }
  @media (min-width: 1200px) {
    font-size: ${max}px;
  }
  `
}

//
// FLEXBOX MIXINS FOR STYLED COMPONENTS
//

export const dFlex = `
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
`;

export const flex = (f1 = 1, fs = 0, fb = 'auto') => `
  -webkit-box-flex: ${f1} ${fs} ${fb};
  -moz-box-flex: ${f1} ${fs} ${fb};
  -ms-flex: ${f1} ${fs} ${fb};
  -webkit-flex: ${f1} ${fs} ${fb};
  flex: ${f1} ${fs} ${fb};
`;

export const flexDirection = (direction) => {
  if (direction === 'row-reverse') {
    return `
      -webkit-box-direction: reverse;
      -webkit-box-orient: horizontal;
      -moz-box-direction: reverse;
      -moz-box-orient: horizontal;
      -webkit-flex-direction: ${direction};
      -ms-flex-direction: ${direction};
      flex-direction: ${direction};
    `;
  } else if (direction === 'column') {
    return `
      -webkit-box-direction: normal;
      -webkit-box-orient: vertical;
      -moz-box-direction: normal;
      -moz-box-orient: vertical;
      -webkit-flex-direction: ${direction};
      -ms-flex-direction: ${direction};
      flex-direction: ${direction};
    `;
  } else if (direction === 'column-reverse') {
    return `
      -webkit-box-direction: reverse;
      -webkit-box-orient: vertical;
      -moz-box-direction: reverse;
      -moz-box-orient: vertical;
      -webkit-flex-direction: ${direction};
      -ms-flex-direction: ${direction};
      flex-direction: ${direction};
    `;
  } else {
    return `
      -webkit-box-direction: normal;
      -webkit-box-orient: horizontal;
      -moz-box-direction: normal;
      -moz-box-orient: horizontal;
      -webkit-flex-direction: ${direction};
      -ms-flex-direction: ${direction};
      flex-direction: ${direction};
    `;
  }
};

export const justifyContent = (value) => {
  if (value === 'flex-start') {
    return `
      -webkit-box-pack: start;
      -moz-box-pack: start;
      -ms-flex-pack: start;
      -webkit-justify-content: ${value};
      justify-content: ${value};
    `;
  } else if (value === 'flex-end') {
    return `
      -webkit-box-pack: end;
      -moz-box-pack: end;
      -ms-flex-pack: end;
      -webkit-justify-content: ${value};
      justify-content: ${value};
    `;
  } else if (value === 'space-between') {
    return `
      -webkit-box-pack: justify;
      -moz-box-pack: justify;
      -ms-flex-pack: justify;
      -webkit-justify-content: ${value};
      justify-content: ${value};
    `;
  } else if (value === 'space-around') {
    return `
      -ms-flex-pack: distribute;
      -webkit-justify-content: ${value};
      justify-content: ${value};
    `;
  } else {
    return `
      -webkit-box-pack: ${value};
      -moz-box-pack: ${value};
      -ms-flex-pack: ${value};
      -webkit-justify-content: ${value};
      justify-content: ${value};
    `;
  }
};

export const alignContent = (value) => {
  if (value === 'flex-start') {
    return `
      -ms-flex-line-pack: start;
      -webkit-align-content: ${value};
      align-content: ${value};
    `;
  } else if (value === 'flex-end') {
    return `
      -ms-flex-line-pack: end;
      -webkit-align-content: ${value};
      align-content: ${value};
    `;
  } else {
    return `
      -ms-flex-line-pack: ${value};
      -webkit-align-content: ${value};
      align-content: ${value};
    `;
  }
};

export const alignItems = (value) => {
  if (value === 'flex-start') {
    return `
      -webkit-box-align: start;
      -moz-box-align: start;
      -ms-flex-align: start;
      -webkit-align-items: ${value};
      align-items: ${value};
    `;
  } else if (value === 'flex-end') {
    return `
      -webkit-box-align: end;
      -moz-box-align: end;
      -ms-flex-align: end;
      -webkit-align-items: ${value};
      align-items: ${value};
    `;
  } else {
    return `
      -webkit-box-align: ${value};
      -moz-box-align: ${value};
      -ms-flex-align: ${value};
      -webkit-align-items: ${value};
      align-items: ${value};
    `;
  }
};

export const alignSelf = (value) => {
  if (value === 'flex-start') {
    return `
      -ms-flex-item-align: start;
      -webkit-align-self: ${value};
      align-self: ${value};
    `;
  } else if (value === 'flex-end') {
    return `
      -ms-flex-item-align: end;
      -webkit-align-self: ${value};
      align-self: ${value};
    `;
  } else {
    return `
      -ms-flex-item-align: ${value};
      -webkit-align-self: ${value};
      align-self: ${value};
    `;
  }
};

export const flexWrap = (value) => {
  if (value === 'no-wrap') {
    return `
      -webkit-flex-wrap: ${value};
      -ms-flex-wrap: none;
      flex-wrap: ${value};
    `;
  } else {
    return `
      -webkit-flex-wrap: ${value};
      -ms-flex-wrap: ${value};
      flex-wrap: ${value};
    `;
  }
};

export const flexFlow = (value) => `
  -webkit-flex-flow: ${value};
  -ms-flex-flow: ${value};
  flex-flow: ${value};
`;

export const flexGrow = (value) => `
  -webkit-box-flex: ${value};
  -moz-box-flex: ${value};
  -webkit-flex-grow: ${value};
  -ms-flex: ${value};
  flex-grow: ${value};
`;

export const flexShrink = (value) => `
  -webkit-flex-shrink: ${value};
  -moz-flex-shrink: ${value};
  -ms-flex: ${value};
  flex-shrink: ${value};
`;

export const flexOrder = (value) => `
  -webkit-box-ordinal-group: ${value + 1};
  -moz-box-ordinal-group: ${value + 1};
  -webkit-order: ${value};
  -ms-flex-order: ${value};
  order: ${value};
`;